<template>
  <div class="header">
    <div class="header__logo" @click="goWorkbench">
      <!-- <el-image v-if="logo" class="image" :src="logo" fit="contain"></el-image> -->
      <img v-if="adminLogo" class="logo-image" :src="adminLogo" alt="" />
      <div v-else class="mark" aria-hidden="true">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <transition name="slide-fade" mode="out-in" :duration="300">
        <div class="title">{{ title }}</div>
      </transition>
    </div>
    <div class="header__menu">
      <el-menu
        mode="horizontal"
        :default-active="currentPath"
        @select="onMenuSelect"
      >
        <template v-for="(nav, idx) in navigator">
          <el-menu-item :key="idx" :index="nav.path" v-if="!nav.meta.hidden">
            <span>{{ nav.meta.title }}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </div>
    <div class="header__right">
      <div class="notice" aria-hidden="true">
        <i class="el-icon-bell"></i>
        <span>12</span>
      </div>
      <el-dropdown @command="onCommand">
        <div class="user">
          <div class="avatar">
            <img v-if="adminAvatar" :src="adminAvatar" alt="" />
            <i v-else class="el-icon-user-solid"></i>
          </div>
          <div class="name">{{ userInfo.name }}</div>
          <i class="el-icon-arrow-down"></i>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="logout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import config from "@/config";
import { getAppTitle, refreshPageTitle, setAppTitle } from "@/utils/app-title";
import { apiGetSystem } from "@/api/setting";

import { asyncRoutes } from "@/router";
import { filterRoutesByPermission, firstVisiblePath } from "@/utils/permission";

export default {
  components: {},
  data() {
    return {
      headerTitle: getAppTitle(),
      adminLogoUrl: "",
      adminAvatarUrl: "",
    };
  },
  computed: {
    ...mapGetters(["userInfo", "permission"]),
    // logo() {
    //   return require("@/assets/images/logo.png");
    // },
    title() {
      return this.headerTitle || config.title;
    },
    adminLogo() {
      return this.formatImageUrl(this.adminLogoUrl);
    },
    adminAvatar() {
      return this.formatImageUrl(this.adminAvatarUrl);
    },
    navigator() {
      return filterRoutesByPermission(asyncRoutes, this.permission);
    },
    currentPath() {
      const parent = this.navigator.find(
        (item) => item.path === this.$route.meta?.parentPath
      );
      return parent ? parent.path : this.$route.path;
    },
  },
  created() {
    this.getSystemTitle();
  },
  methods: {
    getSystemTitle() {
      apiGetSystem().then((resp) => {
        setAppTitle(resp || {});
        this.headerTitle = getAppTitle();
        this.adminLogoUrl = resp?.admin_logo || "";
        this.adminAvatarUrl = resp?.admin_avatar || "";
        refreshPageTitle(this.$route.meta?.title);
      });
    },
    formatImageUrl(url) {
      if (!url) return "";
      if (url.indexOf("uploads/") === 0) {
        return `/${url.replace(/^uploads\//, "upload/")}`;
      }
      if (/^https?:\/\//.test(url) || url.indexOf("/") === 0) {
        return url;
      }
      return `/${url}`;
    },
    navPath(nav) {
      return firstVisiblePath(nav);
    },
    onMenuSelect(path) {
      const nav = this.navigator.find((item) => item.path === path);
      const target = nav ? this.navPath(nav) : path;
      if (target && target !== this.$route.path) {
        this.$router.push(target);
      }
    },
    goWorkbench() {
      if (this.$route.path !== "/workbench") {
        this.$router.push("/workbench");
      }
    },
    onCommand(command) {
      switch (command) {
        case "logout":
          this.logout();
          break;
      }
    },
    logout() {
      this.$store.dispatch("actionLogout").then(() => {
        this.$store.commit("SET_PERMISSION", {});
        this.$router.push("/account/login");
      });
    },
  },
};
</script>

<style lang="scss">
.header {
  height: 100%;
  background: #ffffff;
  border-bottom: 1px solid #e8edf4;
  box-shadow: 0 1px 8px rgba(17, 24, 39, 0.04);
  display: flex;
  align-items: center;
  padding: 0 24px;

  &__logo {
    display: flex;
    align-items: center;
    width: 210px;
    margin-right: 12px;
    cursor: pointer;

    .image {
      width: 34px;
      height: 34px;
      margin-right: 10px;
    }

    .logo-image {
      width: 32px;
      height: 32px;
      flex: 0 0 32px;
      margin-right: 10px;
      object-fit: contain;
      border-radius: 6px;
      display: block;
    }

    .mark {
      position: relative;
      width: 28px;
      height: 28px;
      margin-right: 10px;

      span {
        position: absolute;
        display: block;
        border-radius: 999px;
        box-shadow: 0 5px 10px rgba(37, 99, 235, 0.2);
      }

      span:nth-child(1) {
        left: 3px;
        top: 4px;
        width: 8px;
        height: 8px;
        background: #24b6ff;
      }

      span:nth-child(2) {
        right: 4px;
        top: 4px;
        width: 8px;
        height: 8px;
        background: #2f80ed;
      }

      span:nth-child(3) {
        left: 10px;
        bottom: 3px;
        width: 9px;
        height: 9px;
        background: #3bcf8e;
      }

      span:nth-child(4) {
        left: 8px;
        top: 10px;
        width: 13px;
        height: 7px;
        border-radius: 8px;
        background: linear-gradient(135deg, #1b79ff 0%, #35d39a 100%);
        transform: rotate(35deg);
      }
    }

    .title {
      color: #111827;
      font-size: 16px;
      font-weight: 700;
      letter-spacing: 0;
      white-space: nowrap;
    }
  }

  &__menu {
    flex: 1;
    overflow: hidden;

    .el-menu {
      display: flex;
      height: 56px;
      background: transparent;
      border-bottom: none;

      .el-menu-item {
        position: relative;
        color: #1f2937;
        border: none;
        height: 56px;
        line-height: 56px;
        padding: 0 18px;
        background: transparent !important;

        &:not(.is-disabled):focus,
        &:not(.is-disabled):hover {
          color: #1476ff;
          background: transparent !important;

          span {
            background-color: transparent !important;
          }
        }

        & span {
          font-size: 15px;
          font-weight: 600;
          padding: 0;
          border-radius: 0;
        }

        &.is-active {
          color: #1476ff;

          &::after {
            content: "";
            position: absolute;
            left: 18px;
            right: 18px;
            bottom: 0;
            height: 3px;
            border-radius: 3px 3px 0 0;
            background: #1476ff;
          }

          span {
            color: #1476ff;
            padding: 0;
            background-color: transparent !important;
          }
        }
      }
    }
  }

  &__right {
    display: flex;
    align-items: center;
    gap: 18px;

    .notice {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 28px;
      height: 28px;
      color: #1f2937;
      font-size: 18px;

      span {
        position: absolute;
        top: -5px;
        right: -6px;
        min-width: 16px;
        height: 16px;
        padding: 0 4px;
        border-radius: 9px;
        background: #ff4d4f;
        color: #ffffff;
        font-size: 10px;
        line-height: 16px;
        text-align: center;
        box-sizing: border-box;
      }
    }

    .user {
      height: 56px;
      display: flex;
      align-items: center;
      color: #1f2937;
      cursor: pointer;
      font-weight: 600;

      .avatar {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        margin-right: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ffffff;
        background: linear-gradient(135deg, #dbe5f6 0%, #9fb1cf 100%);
        font-size: 18px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }
      }

      .name {
        margin-right: 4px;
      }
    }
  }
}
</style>
